export * from './platform-name';
export * from './platform-config-manager';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/platform-configs/index.js